import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
// import { TimeagoModule } from 'ngx-timeago';
import { TabViewModule } from 'primeng/tabview';
import { TabMenuModule } from 'primeng/tabmenu';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AccordionModule } from 'primeng/accordion';
import { CardModule } from 'primeng/card';
import { FieldsetModule } from 'primeng/fieldset';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { GMapModule } from 'primeng/gmap';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToolbarModule } from 'primeng/toolbar';
import { LightboxModule } from 'primeng/lightbox';
import { CalendarModule } from 'primeng/calendar';
import { SidebarModule } from 'primeng/sidebar';
import { ChartModule } from 'primeng/chart';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { ChipsModule } from 'primeng/chips';

import { TextBadgeComponent } from './text-badge/text-badge.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SuperInputComponent } from './super-input/super-input.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MessageService, ConfirmationService } from 'primeng/api';
import { StoreDropdownComponent } from '../stores/store-dropdown/store-dropdown.component';
import { ShoppingListPrintLayoutComponent } from '../shopping-list-print-layout/shopping-list-print-layout.component';

export let options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    /* TimeagoModule.forRoot(), */
    NgxMaskModule.forRoot(options),
    NgxSpinnerModule,
    /* PrimeNG Imports */
    MenubarModule,
    InputTextModule,
    InputNumberModule,
    ButtonModule,
    MenuModule,
    TableModule,
    PanelModule,
    TabViewModule,
    GMapModule,
    TabMenuModule,
    CheckboxModule,
    RadioButtonModule,
    AccordionModule,
    CardModule,
    FieldsetModule,
    BreadcrumbModule,
    DialogModule,
    MessageModule,
    SelectButtonModule,
    InputMaskModule,
    InputSwitchModule,
    TooltipModule,
    AutoCompleteModule,
    ToastModule,
    MessagesModule,
    DropdownModule,
    EditorModule,
    ConfirmDialogModule,
    ToolbarModule,
    LightboxModule,
    CalendarModule,
    SidebarModule,
    ChartModule,
    MultiSelectModule,
    ProgressBarModule,
    ChipsModule,
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    TextBadgeComponent,
    SuperInputComponent,
    StoreDropdownComponent,
    ShoppingListPrintLayoutComponent,
    /* TimeagoModule, */
    NgxMaskModule,
    NgxSpinnerModule,
    /* PrimeNG Exports */
    MenubarModule,
    InputTextModule,
    InputNumberModule,
    ButtonModule,
    MenuModule,
    TableModule,
    PanelModule,
    TabViewModule,
    GMapModule,
    TabMenuModule,
    CheckboxModule,
    RadioButtonModule,
    AccordionModule,
    CardModule,
    FieldsetModule,
    BreadcrumbModule,
    DialogModule,
    MessageModule,
    SelectButtonModule,
    InputMaskModule,
    InputSwitchModule,
    TooltipModule,
    AutoCompleteModule,
    ToastModule,
    MessagesModule,
    DropdownModule,
    EditorModule,
    ConfirmDialogModule,
    ToolbarModule,
    LightboxModule,
    CalendarModule,
    SidebarModule,
    ChartModule,
    MultiSelectModule,
    ProgressBarModule,
    ChipsModule,
  ],
  providers: [MessageService, ConfirmationService],
  declarations: [TextBadgeComponent, SuperInputComponent, StoreDropdownComponent, ShoppingListPrintLayoutComponent],
})
export class SharedModule { }
